import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import AddAnother from "../add-another/AddAnother";
import Intervention from "./Intervention";
import { InterventionWithCounter } from "../../types";

function InterventionsContainer({ open }: { open: boolean }) {
  return (
    <Box data-testid="writeable-interventions-container">
      <SectionCollapsible open={open} label="Interventions">
        <AddAnother<InterventionWithCounter>
          name="interventions"
          addLabel="Add intervention"
          getCounter={(intervention) => intervention.interventionCounter}
          createValue={(interventionCounter) => ({
            action: [],
            ecosystem: [],
            interventionCounter,
          })}
          compareValues={(firstIntervention, secondIntervention) =>
            firstIntervention.interventionCounter -
            secondIntervention.interventionCounter
          }
          renderItem={({ value, index, remove }) => (
            <Box sx={{ paddingBottom: 4 }}>
              <Intervention value={value} index={index} remove={remove} />
            </Box>
          )}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default InterventionsContainer;
